import React from "react";
import {
  LegalExternalLink,
  LegalInlineLink,
  LegalNotice,
  LegalParagraph,
  LegalSectionTitle,
  LegalSubTitle,
} from "./LegalDoc.styles";

const INTERNAL_ROUTES = {
  "https://bitcoin.live/policy": "/policy",
  "http://bitcoin.live/policy": "/policy",
  "/policy": "/policy",
  "https://bitcoin.live/terms&conditions": "/terms&conditions",
  "http://bitcoin.live/terms&conditions": "/terms&conditions",
  "/terms&conditions": "/terms&conditions",
  "/terms": "/terms&conditions",
  "/privacy": "/policy",
};

/**
 * Renders prod copy that may contain [[LINK:href|label]] markers from HTML extraction.
 */
export const renderLegalText = (text) => {
  if (!text) return null;
  const parts = String(text).split(/(\[\[LINK:[^\]]+\]\])/g);
  return parts.map((part, index) => {
    const match = part.match(/^\[\[LINK:([^|]+)\|([\s\S]+)\]\]$/);
    if (!match) return <React.Fragment key={index}>{part}</React.Fragment>;
    const [, href, label] = match;
    const internal = INTERNAL_ROUTES[href] || INTERNAL_ROUTES[href.replace(/\/$/, "")];
    if (internal) {
      return (
        <LegalInlineLink key={index} to={internal}>
          {label}
        </LegalInlineLink>
      );
    }
    return (
      <LegalExternalLink key={index} href={href}>
        {label}
      </LegalExternalLink>
    );
  });
};

export const LegalParagraphs = ({ items }) =>
  (items || []).map((text, i) => (
    <LegalParagraph key={i}>{renderLegalText(text)}</LegalParagraph>
  ));

/** Shared structured body: optional notice, intro paras, numbered/lettered sections. */
export const LegalStructuredBody = ({ notice, intro, sections }) => (
  <>
    {notice ? <LegalNotice>{renderLegalText(notice)}</LegalNotice> : null}
    <LegalParagraphs items={intro} />
    {(sections || []).map((section) => (
      <React.Fragment key={section.title}>
        <LegalSectionTitle>{section.title}</LegalSectionTitle>
        <LegalParagraphs items={section.paragraphs} />
        {(section.subs || []).map((sub) => (
          <React.Fragment key={sub.title}>
            <LegalSubTitle>{sub.title}</LegalSubTitle>
            <LegalParagraphs items={sub.paragraphs} />
          </React.Fragment>
        ))}
      </React.Fragment>
    ))}
  </>
);
